import { useTranslation } from "react-i18next";
import { setLocale, type SupportedLocale } from "../../../../i18n";

/**
 * LocaleSwitcher — compact `EN | DE` pair rendered next to the legal links
 * in the auth-page footer. Uses the same mono-eyebrow vocabulary as the
 * STATUS pill so it visually belongs to the chrome, not the form.
 *
 * Persists the choice to localStorage (handled inside `setLocale`).
 */
export function LocaleSwitcher() {
  const { t, i18n } = useTranslation();
  const current = (i18n.language || "en").slice(0, 2) as SupportedLocale;

  const options: SupportedLocale[] = ["en", "de"];

  return (
    <div
      className="auth-locale-switcher"
      role="group"
      aria-label={t("localeSwitcher.ariaLabel")}
    >
      {options.map((code, idx) => (
        <span key={code} className="auth-locale-switcher__item">
          <button
            type="button"
            onClick={() => setLocale(code)}
            aria-pressed={current === code}
            className={
              current === code
                ? "auth-locale-switcher__btn auth-locale-switcher__btn--active"
                : "auth-locale-switcher__btn"
            }
          >
            {t(`localeSwitcher.${code}`)}
          </button>
          {idx < options.length - 1 && (
            <span aria-hidden="true" className="auth-locale-switcher__sep">
              ·
            </span>
          )}
        </span>
      ))}
    </div>
  );
}
